export default {
  user_module_globalLegalCompliance_evaluation: {
    path:
      'global-legal-compliance/:moduleBridgeHex/evaluation/:page/:filtersHex/',
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_globalLegalCompliance_calendar: {
    path:
      'global-legal-compliance/:moduleBridgeHex/calendar/',
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
};
